import moment from 'moment';

const getRentInsuranceDaysLeft = (lease) => {
  if (!lease) return null;

  return moment(lease.start_date).diff(moment().startOf('day'), 'days');
};

export default getRentInsuranceDaysLeft;
